import { render, staticRenderFns } from "./PhoneAddress.vue?vue&type=template&id=2ddfa350"
import script from "./PhoneAddress.vue?vue&type=script&lang=js"
export * from "./PhoneAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports